import { useTranslation } from "react-i18next";
import {
  HatchBandCorner,
  HatchBandOverFooter,
  hatchBandFooterEdge,
  cn,
} from "@jbnl/shared-ui";

/**
 * Full-bleed rather than aligned to the reading column, because on the sheet it is a band across
 * the page. The printed KvK and bank numbers are left off: nothing here is filed or paid against.
 */
export function Footer({ className }: { className?: string }) {
  const { t } = useTranslation();

  return (
    <>
      {/* Fills the gap overscroll opens below the footer. Outside the footer's stacking context,
or it would be promoted with it and paint over the page. `h-64` rather than `h-screen`:
a full viewport's worth reaches the gap that opens at the top instead. */}
      <div
        aria-hidden
        className="pointer-events-none fixed inset-x-0 bottom-0 -z-10 h-64 bg-brand-red"
      />
      {/* Same fix as the fill above, carrying the hatch rather than plain red: below lg the strip
is `absolute` and stops at the footer's edge. `background-attachment: fixed` is what
lines the two strips up as one pattern. */}
      <div
        aria-hidden
        className="jb-hatch-band pointer-events-none fixed right-0 bottom-0 -z-10 h-64 w-[52px] lg:hidden"
      />
      {/* `mt-auto` needs the page frame to be a flex column: on a short page it is what holds
          the band at the foot of the viewport instead of leaving it under the last card. */}
      <footer
        className={cn(
          "relative z-0 mt-auto bg-brand-red py-3 pl-6 text-xs text-white",
          hatchBandFooterEdge,
          className,
        )}
      >
        {/* Wrapping does the rest: on a phone the two halves stack, and the band beside them is
            the same 11mm it is on a laptop. */}
        <div className="flex flex-wrap items-center justify-between gap-x-6 gap-y-1">
          <span>{t("footer.stichting")}</span>
          <span className="font-bold">{t("footer.website")}</span>
        </div>
        <HatchBandCorner />
        <HatchBandOverFooter />
      </footer>
    </>
  );
}
